(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-joc-rotating-collection"] && !Shopify.designMode) return;
  try {
    
(() => {
  const seen = new Set();
  const completed = new WeakSet();

  function groupFor(item) {
    const text = item.title.toLowerCase().split('|').pop();
    const families = [
      ['mugs', /\bmug\b|\bmugs\b/],
      ['tumblers', /tumbler|travel cup|water bottle/],
      ['sweatshirts', /sweatshirt|hoodie|pullover/],
      ['t-shirts', /t-shirt|\btee\b|\btees\b/],
      ['sweaters', /sweater|cardigan/],
      ['dresses', /\bdress\b/],
      ['jeans', /\bjeans\b/],
      ['jumpsuits', /jumpsuit|overalls/],
      ['shoes', /sandals|boots|sneakers|shoes/],
      ['earrings', /earrings/],
      ['necklaces', /necklace/],
      ['bracelets', /bracelet/],
      ['rings', /\bring\b|\brings\b/],
      ['signs', /\bsign\b|\bsigns\b/],
      ['candles', /candle/],
      ['journals', /journal|notebook/],
      ['bags', /handbag|tote|purse|\bbag\b|pouch/],
      ['chargers', /charger/],
      ['syrups', /syrup|sauce/]
    ];
    return families.find(([, pattern]) => pattern.test(text))?.[0] || item.type.toLowerCase() || 'other';
  }

  function pick(items, limit, previous, alreadySeen, random = Math.random) {
    const unique = [...new Map(items.map(item => [item.id, item])).values()];
    const remaining = unique.map(item => ({...item, group: groupFor(item)}));
    const selected = [];
    const counts = new Map();
    const previousSet = new Set(previous);
    while (remaining.length && selected.length < limit) {
      let winner = 0;
      let lowest = Infinity;
      remaining.forEach((item, index) => {
        const repeat = selected.length && selected[selected.length - 1].group === item.group;
        const score = (repeat ? 1000 : 0) + (counts.get(item.group) || 0) * 100
          + (alreadySeen.has(item.id) ? 200 : 0) + (previousSet.has(item.id) ? 20 : 0) + random();
        if (score < lowest) { lowest = score; winner = index; }
      });
      const [item] = remaining.splice(winner, 1);
      selected.push(item);
      counts.set(item.group, (counts.get(item.group) || 0) + 1);
    }
    if (selected.length && remaining.length && selected.every(item => previousSet.has(item.id))) {
      const replacement = remaining.find(item => !previousSet.has(item.id));
      if (replacement) selected[selected.length - 1] = replacement;
    }
    if (selected.length > 1 && selected[0].id === previous[0]) {
      const index = selected.findIndex((item, i) => i > 0 && item.group === selected[0].group);
      const swap = index > 0 ? index : 1;
      [selected[0], selected[swap]] = [selected[swap], selected[0]];
    }
    return selected;
  }

  function rotate(section) {
    if (completed.has(section)) return;
    const grid = section.querySelector('[data-joc-grid]');
    const templates = [...section.querySelectorAll('template[data-joc-product]')];
    if (!grid || !templates.length) return;
    const items = templates.map(template => ({
      id: template.dataset.jocProduct,
      title: template.dataset.title || '',
      type: template.dataset.productType || '',
      template
    }));
    const limit = Math.max(1, Number(section.dataset.jocLimit) || 4);
    const storageKey = `joc-home-rotation-v1:${section.dataset.sectionId}`;
    let previous = [];
    try {
      const stored = JSON.parse(localStorage.getItem(storageKey) || '[]');
      if (Array.isArray(stored)) previous = stored.filter(id => typeof id === 'string');
    } catch (_) {}
    const selection = pick(items, limit, previous, seen);
    const fragment = document.createDocumentFragment();
    for (const item of selection) {
      const node = item.template.content.firstElementChild?.cloneNode(true);
      if (!node) return;
      node.dataset.jocSelected = item.id;
      fragment.appendChild(node);
    }
    grid.replaceChildren(fragment);
    selection.forEach(item => seen.add(item.id));
    completed.add(section);
    section.dataset.jocRotated = 'true';
    section.dataset.jocPoolSize = String(items.length);
    try { localStorage.setItem(storageKey, JSON.stringify(selection.map(item => item.id))); } catch (_) {}
  }

  function init(root = document) {
    if (root.matches?.('[data-joc-rotation]')) rotate(root);
    root.querySelectorAll('[data-joc-rotation]').forEach(rotate);
  }

  window.JOCHomeRotation = {pick, init};
  init();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), {once: true});
  document.addEventListener('shopify:section:load', event => init(event.target), true);
})();

  } catch(e) { console.error(e); }
})();
})();
